import { useEffect } from "react";
import { useLocation, Route, Routes, useNavigate } from "react-router-dom";
import { useGlobalContext } from "./context/globalContext";

// Existing imports
import Home from "./pages/home";
import Login from "./pages/login";
import Resolved from "./pages/resolved";
import Unresolved from "./pages/unresolved";
import All from "./pages/all";
import Info from "./pages/info";
import Stats from "./pages/stats";
import Profile from "./pages/profile";
import History from "./pages/history";
import UserHistory from "./pages/[userName]";
import TopPerformers from "./pages/topPerformers";
import Announcements from "./pages/announcements";
import MonthlyUserHistory from "./pages/monthlyUserHistory";
import CurrUsersStats from "./pages/currUsersStats";
import SignUp from "./pages/signUp";
import Navbar from "./components/navbar.jsx";
import Dashboard from "./pages/dashboard.jsx";
import Incentives from "./pages/incentives.jsx";
import CallScore from "./pages/callScore.jsx";
import Chatbot from "./pages/chatbot.jsx";
import UserManagement from "./pages/userManagement.jsx";
import CourseManagement from "./pages/CourseManagement.jsx";

// New Analytics Components
import AnalyticsLayout from "./components/analytics/layout.jsx";
import SalesDashboard from "./pages/analytics/SalesDashboard";
import TransactionsDashboard from "./pages/analytics/SalesTransactionDashboard";
import RevenueDashboard from "./pages/analytics/RevenueDashboard";
import PerformanceDashboard from "./pages/analytics/PerformanceDashboard.jsx";
import LeadsDashboard from "./pages/analytics/LeadsDashboard";
import ContactsDashboard from "./pages/analytics/ContactsDashboard";
import TrendsDashboard from "./pages/analytics/TrendsDashboard";
import ManageAgents from "./pages/analytics/ManageAgents.jsx";
import UpiPayment from "./pages/upiPaymentQueries";

// Mentorship Components
import MentorshipDashboard from "./pages/mentorship/index";
import CourseDetail from "./pages/mentorship/course/[id]";


function App() {
    const { userInfo, setUserInfo } = useGlobalContext();
    const navigate = useNavigate();
    const location = useLocation();
    const allowedEmails = ['shantanuesakpal1420@gmail.com'];

    useEffect(() => {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        if (userInfo) {
            setUserInfo(userInfo);
        } else {
            navigate("/login");
        }
    }, []);

    const showSidebar = !["/login", "/signup"].includes(location.pathname) && 
                       !location.pathname.startsWith("/analytics");

    return (
        <div className="flex w-screen h-screen">
            <div className="w-fit">
                {showSidebar && <Navbar />}
            </div>
            <div className="w-full overflow-x-scroll overflow-y-scroll">
                <Routes>
                    {/* Auth Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<SignUp />} />

                    {/* Main Application Routes */}
                    <Route path="/" element={userInfo && <Home />} />
                    <Route path="/all" element={userInfo && <All />} />
                    <Route path="/resolved" element={userInfo && <Resolved />} />
                    <Route path="/unresolved" element={userInfo && <Unresolved />} />
                    <Route path="/topperformers" element={userInfo && <TopPerformers />} />
                    <Route path="/profile" element={!userInfo?.isAdmin && <Profile />} />
                    <Route path="/history" element={userInfo && <History />} />
                    <Route path="/stats" element={userInfo?.isAdmin && <Stats />} />
                    <Route path="/chatbot" element={<Chatbot />} />
                    <Route path="/current-users-stats" element={userInfo?.isAdmin && <CurrUsersStats />} />
                    <Route path="/monthly-user-history" element={userInfo?.isAdmin && <MonthlyUserHistory />} />
                    <Route path="/dashboard" element={userInfo?.isAdmin && <Dashboard />} />
                    <Route path="/call-score" element={userInfo && <CallScore />} />
                    <Route path="/announcements" element={userInfo && <Announcements />} />
                    <Route path="/incentives" element={allowedEmails.includes(userInfo?.email) && <Incentives />} />
                    <Route path="/users/:userName" element={userInfo?.isAdmin && <UserHistory />} />
                    <Route path="/upipayment" element={userInfo?.isAdmin && <UpiPayment />} />
                    <Route path="/info" element={userInfo && <Info />} />
                    <Route path="/user-management" element={userInfo?.isAdmin && <UserManagement />} />
                    <Route path="/course-management" element={userInfo?.isAdmin && <CourseManagement />} />

                    {/* Analytics Routes */}
                    <Route 
                        path="/analytics" 
                        element={<AnalyticsLayout/>}
                    >
                        <Route path="sales" element={<SalesDashboard />} />
                        <Route path="transactions" element={<TransactionsDashboard />} />
                        <Route path="revenue" element={<RevenueDashboard />} />
                        <Route path="performance" element={<PerformanceDashboard />} />
                        <Route path="leads" element={<LeadsDashboard />} />
                        <Route path="contacts" element={<ContactsDashboard />} />
                        <Route path="trends" element={<TrendsDashboard />} />
                        <Route path="manage-agents" element={<ManageAgents />} />
                    </Route>

                    {/* Mentorship Routes - Only for Admin Users */}
                    <Route path="/mentorship" element={userInfo?.isAdmin && <MentorshipDashboard />} />
                    <Route path="/mentorship/course/:id" element={userInfo?.isAdmin && <CourseDetail />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;